module.exports = __webpack_public_path__ + "assets/img/20220623-1.67139bac.png";